<template>
  <div>
    <h1 class="text-7xl">Hello,</h1>
    <h1 class="text-3xl">I am Prayog Paudel</h1>
    <h1 class="text-3xl">Mandikhatar, KTM</h1>
    <h1 class="text-3xl">+977-9840063248</h1>
    <fieldset
      class="border-solid border-2 border-rounded mt-5 pt-10 p-1 pb-5 border-color"
    >
      <legend class="border-solid border-2 ml-10 p-1 border-color">
        Skills
      </legend>
      <IconArray />
    </fieldset>
    <fieldset
      class="border-solid border-2 border-rounded pt-10 p-1 pb-5 border-color"
      :class="{ 'mt-5': smallScreen, 'mt-24': !smallScreen }"
    >
      <legend class="border-solid border-2 ml-10 p-1 border-color">
        Links
      </legend>
      <SocialMedias />
    </fieldset>
  </div>
</template>

<script>
import IconArray from './icons'
import SocialMedias from './social-medias'

export default {
  components: {
    IconArray,
    SocialMedias,
  },
  computed: {
    smallScreen() {
      return window.innerWidth <= 1280
    },
  },
}
</script>

<style></style>
